import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import {
  createViolationResultItemService,
  deleteViolationResultItemService,
  editViolationResultItemService,
  getViolationResultItemsService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const violationResultAdminContext = createContext({
  violationResultItems: [],
  setViolationResultItems: () => {},
  violationResult: {},
  setViolationResult: () => {},
  id: "",
  setId: () => {},
  icon: "",
  setIcon: () => {},
  description: "",
  setDescription: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  isShowDetailsModal: null,
  setIsShowDetailsModal: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  handleShowModal: () => {},
  handleCloseModal: () => {},
  handleShowDetailsModal: () => {},
  handleCloseDetailsModal: () => {},
  handleGetViolationResultItemList: () => {},
  handleCreateViolationResultItem: () => {},
  handleEditViolationResultItem: () => {},
  handleDeleteViolationResultItem: () => {},
});

const ViolationResultAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [violationResultItems, setViolationResultItems] = useState([]);
  const [violationResult, setViolationResult] = useState({});
  const [id, setId] = useState("");
  const [icon, setIcon] = useState("");
  const [description, setDescription] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowDetailsModal, setIsShowDetailsModal] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);

  const handleResetState = () => {
    setId("");
    setIcon("");
    setDescription("");
  };

  // Create Violation Result Modal Operations
  const handleShowModal = (itemValue) => {
    setIsShowModal(true);
    if (itemValue) {
      setId(itemValue.id);
      setIcon(itemValue.icon);
      setDescription(itemValue.description);
    }
  };
  const handleCloseModal = () => {
    setIsShowModal(false);
    handleResetState();
  };

  // Details Violation Result Modal Operations
  const handleShowDetailsModal = (value) => {
    setIsShowDetailsModal(true);
    setViolationResult(value);
  };
  const handleCloseDetailsModal = () => {
    setIsShowDetailsModal(false);
    setViolationResult({});
  };

  // Handle Get Violation Result Item List Method
  const handleGetViolationResultItemList = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getViolationResultItemsService(objData);
      if (status === 200) {
        setViolationResultItems(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create Violation Result Item Method
  const handleCreateViolationResultItem = async (event) => {
    event?.preventDefault();

    const objData = {
      icon,
      description,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createViolationResultItemService(objData);
      if (status === 201) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetViolationResultItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Violation Result Item Method
  const handleEditViolationResultItem = async (event) => {
    event?.preventDefault();

    const objData = {
      id,
      icon,
      description,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editViolationResultItemService(objData);
      if (status === 201) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetViolationResultItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete Violation Result Item Method
  const handleDeleteViolationResultItem = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteViolationResultItemService(id);
      if (status === 200) {
        toastSuccessMessage(`آیتم  ${id} با موفقیت حذف شد`);
        handleGetViolationResultItemList();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <violationResultAdminContext.Provider
      value={{
        violationResultItems,
        setViolationResultItems,
        violationResult,
        setViolationResult,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        id,
        setId,
        icon,
        setIcon,
        description,
        setDescription,
        isShowModal,
        setIsShowModal,
        isShowDetailsModal,
        setIsShowDetailsModal,
        handleShowDetailsModal,
        handleCloseDetailsModal,
        handleShowModal,
        handleCloseModal,
        handleGetViolationResultItemList,
        handleCreateViolationResultItem,
        handleEditViolationResultItem,
        handleDeleteViolationResultItem,
      }}
    >
      {children}
    </violationResultAdminContext.Provider>
  );
};

export default ViolationResultAdminContext;
